import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { TransactionsPage } from '@/features/accounting/transactions/components/TransactionsPage';

const searchSchema = z.object({
  columnFilters: z
    .array(
      z.object({
        id: z.string(),
        value: z.unknown(),
      })
    )
    .optional(),
});

export const Route = createFileRoute('/$commiteeSlug/accounting/transactions/{-$id}')({
  validateSearch: searchSchema,
  component: TransactionsPage,
});
